import styled from 'styled-components'

export const ModalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`

export const InnerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`

export const List = styled.ul`
    list-style: inside;
    padding-left: 10px;
    padding-bottom: 10px;
`
